import { render } from "./BCardSeller.vue?vue&type=template&id=2c2ece5c&scoped=true"
import script from "./BCardSeller.vue?vue&type=script&lang=js"
export * from "./BCardSeller.vue?vue&type=script&lang=js"

import "./BCardSeller.vue?vue&type=style&index=0&id=2c2ece5c&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2ece5c"]])

export default __exports__